import { strToU8, zip } from 'fflate';
import type { ScormPackageInput } from '../types';
import { buildImsManifest } from './manifest';
import { buildEntryHtml } from './entryHtml';
import { buildScormShim } from './scormShim';

function getPlayerOrigin(launchUrl: string): string {
  return new URL(launchUrl).origin;
}

function zipAsync(files: Record<string, Uint8Array>): Promise<Uint8Array> {
  return new Promise((resolve, reject) => {
    zip(files, { level: 6 }, (err, data) => {
      if (err) reject(err);
      else resolve(data);
    });
  });
}

export async function generateScormPackage(input: ScormPackageInput): Promise<Blob> {
  const playerOrigin = getPlayerOrigin(input.playerLaunchUrl);
  const meta = {
    format: 'libertify-scorm-1.2',
    version: 1,
    experience: input.experience,
    options: input.options,
    generatedAt: new Date().toISOString(),
  };

  const files: Record<string, Uint8Array> = {
    'imsmanifest.xml': strToU8(buildImsManifest(input)),
    'experience/index.html': strToU8(buildEntryHtml(input)),
    'shared/scorm-shim.js': strToU8(buildScormShim(playerOrigin)),
    'meta.json': strToU8(JSON.stringify(meta, null, 2)),
  };

  const zipped = await zipAsync(files);
  // Buffer copy keeps the Blob backing data independent from the typed array's
  // underlying buffer, so callers can safely revoke object URLs without affecting it.
  return new Blob([zipped.slice()], { type: 'application/zip' });
}
